import { SlaI } from '../interfaces/sla.interface'
import { SlaService } from '../services/sla.service'
import {
    SlaCalculateMinDeliveryDateParams,
    SlaCalculateMinDeliveryDateResponse,
    SlaCreatePayloadT,
    SlaCreateResponseT,
    SlaDeleteResponseT,
    SlaExportExcelParams,
    SlaGetListParams,
    SlaGetListResponseT,
    SlaUpdateResponseT,
} from '../types/sla.types'

const slaService = new SlaService()

class SlaRealisation implements SlaI {
    getList(params: SlaGetListParams): Promise<SlaGetListResponseT> {
        return slaService.getList(params)
    }

    getListFtl(params: SlaGetListParams): Promise<SlaGetListResponseT> {
        return slaService.getListFtl(params)
    }

    createSLA(sla_payload: SlaCreatePayloadT): Promise<SlaCreateResponseT> {
        return slaService.createSLA(sla_payload)
    }

    createSlaFtl(sla_payload: SlaCreatePayloadT): Promise<SlaCreateResponseT> {
        return slaService.createSlaFtl(sla_payload)
    }

    updateSLA(sla_id: number, sla_payload: SlaCreatePayloadT): Promise<SlaUpdateResponseT> {
        return slaService.updateSLA(sla_id, sla_payload)
    }

    updateSlaFtl(sla_id: number, sla_payload: SlaCreatePayloadT): Promise<SlaUpdateResponseT> {
        return slaService.updateSlaFtl(sla_id, sla_payload)
    }

    deleteSLA(sla_id: number): Promise<SlaDeleteResponseT> {
        return slaService.deleteSLA(sla_id)
    }

    deleteSlaFtl(sla_id: number): Promise<SlaDeleteResponseT> {
        return slaService.deleteSlaFtl(sla_id)
    }

    importFromExcel(form_data: FormData): Promise<void> {
        return slaService.importFromExcel(form_data)
    }

    exportExcel(params: SlaExportExcelParams): Promise<any> {
        return slaService.exportExcel(params)
    }

    calculateMinDeliveryDate(params: SlaCalculateMinDeliveryDateParams): Promise<SlaCalculateMinDeliveryDateResponse> {
        return slaService.calculateMinDeliveryDate(params)
    }
}

export const SLA = new SlaRealisation()
